import { useCallback, useEffect, useState } from 'react';
import { Alert, Badge, Button, Group, Loader, Modal, ScrollArea, Table, Text, TextInput } from '@mantine/core';
import { portalJson } from './lib/nativeApi.js';

const ACTIONS = {
  UPLOAD: 'Dosya yükleme', DOWNLOAD: 'PDF indirme', TEXT_EDIT: 'Metin düzenleme',
  IMAGE_MOVE: 'Görsel taşıma', IMAGE_REPLACE: 'Görsel değiştirme',
  UNDO: 'Geri al', REDO: 'Yinele', CLOSE: 'Oturumu kapatma',
  PAGE_ROTATE: 'Sayfa döndürme', PAGE_DELETE: 'Sayfa silme', PAGE_REORDER: 'Sayfa sıralama',
  PDF_MERGE: 'PDF birleştirme', PDF_SPLIT: 'PDF bölme', PDF_EXPORT: 'PDF dışa aktarma',
  ADD_IMAGE: 'Görsel ekleme', ADD_TEXT: 'Metin ekleme', ADD_PAGE: 'Sayfa ekleme',
};

function dateFromUTC(value) {
  if (!value) return '-';
  const iso = /(?:Z|[+\-]\d{2}:?\d{2})$/.test(value) ? value : `${value}Z`;
  const parsed = new Date(iso);
  return Number.isNaN(parsed.getTime()) ? String(value) : parsed.toLocaleString('tr-TR');
}

export default function PdfStudioAuditPanel({ opened, onClose }) {
  const [events, setEvents] = useState([]);
  const [userId, setUserId] = useState('');
  const [documentId, setDocumentId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const refresh = useCallback(async () => {
    setLoading(true); setError('');
    try {
      const params = new URLSearchParams({ limit: '100' });
      if (userId.trim()) {
        if (!/^\d+$/.test(userId.trim())) throw new Error('Kullanıcı ID sayısal olmalı.');
        params.set('user_id', userId.trim());
      }
      if (documentId.trim()) params.set('document_id', documentId.trim());
      setEvents(await portalJson(`/audit?${params.toString()}`));
    } catch (e) { setError(e.message); setEvents([]); }
    finally { setLoading(false); }
  }, [userId, documentId]);
  useEffect(() => { if (opened) void refresh(); }, [opened]);
  return (
    <Modal opened={opened} onClose={onClose} title="PDF Studio — Kullanıcı İşlem Kayıtları"
      size="xl" centered scrollAreaComponent={ScrollArea.Autosize}>
      <Group mb="sm" gap="sm" align="end" wrap="wrap">
        <TextInput label="Kullanıcı ID" placeholder="Tümü" value={userId} onChange={(e) => setUserId(e.currentTarget.value)} />
        <TextInput label="Belge ID" placeholder="Tümü" value={documentId} onChange={(e) => setDocumentId(e.currentTarget.value)} style={{flex:1}} />
        <Button onClick={refresh} loading={loading}>Sorgula</Button>
      </Group>
      {error && <Alert color="red" mb="sm">{error}</Alert>}
      {loading ? <Loader size="sm" /> : <ScrollArea h={440} type="auto">
        <Table striped highlightOnHover stickyHeader withColumnBorders miw={850}>
          <Table.Thead><Table.Tr>
            <Table.Th>Tarih</Table.Th><Table.Th>Kullanıcı</Table.Th><Table.Th>Belge</Table.Th>
            <Table.Th>İşlem</Table.Th><Table.Th>Durum</Table.Th><Table.Th>Doğrulama</Table.Th>
          </Table.Tr></Table.Thead>
          <Table.Tbody>{events.map((evt) => <Table.Tr key={evt.id}>
            <Table.Td><Text size="xs">{dateFromUTC(evt.at_utc)}</Text></Table.Td>
            <Table.Td>{evt.user_id}</Table.Td>
            <Table.Td><Text size="xs" title={evt.document_id} lineClamp={1}>{evt.document_id || '-'}</Text></Table.Td>
            <Table.Td>{ACTIONS[evt.action] || evt.action}</Table.Td>
            <Table.Td><Badge color={evt.status === 'success' ? 'green' : evt.status === 'rejected' ? 'red' : 'gray'}>{evt.status}</Badge></Table.Td>
            <Table.Td><Badge color={evt.verified ? 'teal' : 'gray'} variant="light">{evt.verified ? 'Sunucu' : 'İstemci bildirimi'}</Badge></Table.Td>
          </Table.Tr>)}</Table.Tbody>
        </Table>
        {!events.length && !error && <Text c="dimmed" size="sm" py="xl" ta="center">Bu filtrede kayıt bulunamadı.</Text>}
      </ScrollArea>}
    </Modal>
  );
}
